import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowRight, Sparkles, Users, Trophy, Heart, Star, Zap, Target, Award, TrendingUp, CheckCircle2 } from 'lucide-react';
export function BrandAmbassador() {
  return <div className="w-full bg-gray-50" data-id="element-335">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#0E578E] to-[#01AAE7] py-16 sm:py-20 overflow-hidden" data-id="element-336">
        {/* Animated Background Elements */}
        <div className="absolute inset-0 opacity-10" data-id="element-337">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse" data-id="element-338"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse" style={{
          animationDelay: '1s'
        }} data-id="element-339"></div>
        </div>

        {/* Diagonal Lines Pattern */}
        <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: `repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.1) 35px, rgba(255,255,255,.1) 70px)`
      }} data-id="element-340"></div>

        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10 text-center" data-id="element-341">
          {/* Main Heading */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mb-6 leading-tight" data-id="element-342">
            Become a RaceLookup
            <span className="block mt-2 bg-gradient-to-r from-white via-cyan-100 to-white bg-clip-text text-transparent" data-id="element-343">
              Brand Ambassador
            </span>
          </h1>

          {/* Description */}
          <p className="text-lg sm:text-xl text-white/90 leading-relaxed max-w-3xl mx-auto mb-8" data-id="element-344">
            Join an elite community of passionate runners who represent
            RaceLookup. Share your love for running, inspire others, and earn
            exclusive rewards.
          </p>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-4 max-w-2xl mx-auto" data-id="element-345">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20" data-id="element-346">
              <div className="text-3xl font-black text-white mb-1" data-id="element-347">500K+</div>
              <div className="text-xs text-white/80 font-semibold" data-id="element-348">
                Active Runners
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20" data-id="element-349">
              <div className="text-3xl font-black text-white mb-1" data-id="element-350">180</div>
              <div className="text-xs text-white/80 font-semibold" data-id="element-351">
                Countries
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20" data-id="element-352">
              <div className="text-3xl font-black text-white mb-1" data-id="element-353">10K+</div>
              <div className="text-xs text-white/80 font-semibold" data-id="element-354">
                Events Listed
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What is a Brand Ambassador Section */}
      <section className="py-16 sm:py-20 bg-white" data-id="element-355">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-356">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-357">
            <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-4" data-id="element-358">
              What is a Brand Ambassador?
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-359">
              RaceLookup Brand Ambassadors are passionate runners who embody our
              mission to connect the global running community. As an ambassador,
              you'll represent our brand at races, on social media, and within
              your local running circles.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-360">
            <div className="text-center" data-id="element-361">
              <div className="w-16 h-16 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-2xl flex items-center justify-center mx-auto mb-4" data-id="element-362">
                <Target className="h-8 w-8 text-white" data-id="element-363" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-364">
                Share Your Passion
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-365">
                Inspire others through your running journey and help grow the
                RaceLookup community
              </p>
            </div>

            <div className="text-center" data-id="element-366">
              <div className="w-16 h-16 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-2xl flex items-center justify-center mx-auto mb-4" data-id="element-367">
                <Users className="h-8 w-8 text-white" data-id="element-368" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-369">
                Build Connections
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-370">
                Network with fellow ambassadors and runners worldwide through
                exclusive events
              </p>
            </div>

            <div className="text-center" data-id="element-371">
              <div className="w-16 h-16 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-2xl flex items-center justify-center mx-auto mb-4" data-id="element-372">
                <Award className="h-8 w-8 text-white" data-id="element-373" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-374">
                Earn Rewards
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-375">
                Get exclusive perks, discounts, and recognition for your
                contributions
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 sm:py-20 bg-gray-50" data-id="element-376">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-377">
          <div className="text-center mb-12" data-id="element-378">
            <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-4" data-id="element-379">
              Ambassador Benefits
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-380">
              As a RaceLookup Brand Ambassador, you'll receive exclusive
              benefits designed to support your running journey
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-381">
            {/* Benefit 1 */}
            <div className="bg-white rounded-2xl p-6 sm:p-8 border-2 border-gray-100 hover:border-[#01AAE7] transition-all" data-id="element-382">
              <div className="w-14 h-14 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center mb-4" data-id="element-383">
                <Trophy className="h-7 w-7 text-white" data-id="element-384" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-385">
                Exclusive Merchandise
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-386">
                Receive free RaceLookup branded gear including running apparel,
                accessories, and limited edition items
              </p>
            </div>

            {/* Benefit 2 */}
            <div className="bg-white rounded-2xl p-6 sm:p-8 border-2 border-gray-100 hover:border-[#01AAE7] transition-all" data-id="element-387">
              <div className="w-14 h-14 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center mb-4" data-id="element-388">
                <Star className="h-7 w-7 text-white" data-id="element-389" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-390">
                Race Discounts
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-391">
                Get up to 50% off race registrations and exclusive access to
                sold-out events through our partner network
              </p>
            </div>

            {/* Benefit 3 */}
            <div className="bg-white rounded-2xl p-6 sm:p-8 border-2 border-gray-100 hover:border-[#01AAE7] transition-all" data-id="element-392">
              <div className="w-14 h-14 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center mb-4" data-id="element-393">
                <Zap className="h-7 w-7 text-white" data-id="element-394" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-395">
                Early Access
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-396">
                Be the first to try new features, access beta programs, and get
                insider updates before public release
              </p>
            </div>

            {/* Benefit 4 */}
            <div className="bg-white rounded-2xl p-6 sm:p-8 border-2 border-gray-100 hover:border-[#01AAE7] transition-all" data-id="element-397">
              <div className="w-14 h-14 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center mb-4" data-id="element-398">
                <Users className="h-7 w-7 text-white" data-id="element-399" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-400">
                Ambassador Network
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-401">
                Join a private community of ambassadors with exclusive events,
                meetups, and networking opportunities
              </p>
            </div>

            {/* Benefit 5 */}
            <div className="bg-white rounded-2xl p-6 sm:p-8 border-2 border-gray-100 hover:border-[#01AAE7] transition-all" data-id="element-402">
              <div className="w-14 h-14 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center mb-4" data-id="element-403">
                <TrendingUp className="h-7 w-7 text-white" data-id="element-404" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-405">
                Content Features
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-406">
                Get featured on our blog, social media channels, and
                newsletters. Share your story with 500K+ runners
              </p>
            </div>

            {/* Benefit 6 */}
            <div className="bg-white rounded-2xl p-6 sm:p-8 border-2 border-gray-100 hover:border-[#01AAE7] transition-all" data-id="element-407">
              <div className="w-14 h-14 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center mb-4" data-id="element-408">
                <Heart className="h-7 w-7 text-white" data-id="element-409" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-410">
                Priority Support
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-411">
                Receive dedicated customer support and direct communication with
                the RaceLookup team
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Requirements Section */}
      <section className="py-16 sm:py-20 bg-white" data-id="element-412">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-413">
          <div className="text-center mb-12" data-id="element-414">
            <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-4" data-id="element-415">
              Who Can Apply?
            </h2>
            <p className="text-lg text-gray-600" data-id="element-416">
              We're looking for passionate runners who embody the RaceLookup
              spirit
            </p>
          </div>

          <div className="bg-gray-50 rounded-2xl p-8 sm:p-10 border-2 border-gray-100" data-id="element-417">
            <ul className="space-y-4" data-id="element-418">
              <li className="flex items-start gap-4" data-id="element-419">
                <div className="w-6 h-6 bg-[#01AAE7] rounded-full flex items-center justify-center flex-shrink-0 mt-1" data-id="element-420">
                  <CheckCircle2 className="h-4 w-4 text-white" data-id="element-421" />
                </div>
                <div data-id="element-422">
                  <div className="font-bold text-gray-900 mb-1 text-lg" data-id="element-423">
                    Active Runner
                  </div>
                  <div className="text-gray-600" data-id="element-424">
                    Participate in at least 3-4 races per year (any distance)
                  </div>
                </div>
              </li>

              <li className="flex items-start gap-4" data-id="element-425">
                <div className="w-6 h-6 bg-[#01AAE7] rounded-full flex items-center justify-center flex-shrink-0 mt-1" data-id="element-426">
                  <CheckCircle2 className="h-4 w-4 text-white" data-id="element-427" />
                </div>
                <div data-id="element-428">
                  <div className="font-bold text-gray-900 mb-1 text-lg" data-id="element-429">
                    Social Media Presence
                  </div>
                  <div className="text-gray-600" data-id="element-430">
                    Active on at least one social platform (Instagram, Facebook,
                    Twitter, or TikTok)
                  </div>
                </div>
              </li>

              <li className="flex items-start gap-4" data-id="element-431">
                <div className="w-6 h-6 bg-[#01AAE7] rounded-full flex items-center justify-center flex-shrink-0 mt-1" data-id="element-432">
                  <CheckCircle2 className="h-4 w-4 text-white" data-id="element-433" />
                </div>
                <div data-id="element-434">
                  <div className="font-bold text-gray-900 mb-1 text-lg" data-id="element-435">
                    Community Engagement
                  </div>
                  <div className="text-gray-600" data-id="element-436">
                    Involved in local running clubs or communities
                  </div>
                </div>
              </li>

              <li className="flex items-start gap-4" data-id="element-437">
                <div className="w-6 h-6 bg-[#01AAE7] rounded-full flex items-center justify-center flex-shrink-0 mt-1" data-id="element-438">
                  <CheckCircle2 className="h-4 w-4 text-white" data-id="element-439" />
                </div>
                <div data-id="element-440">
                  <div className="font-bold text-gray-900 mb-1 text-lg" data-id="element-441">
                    Passion for Running
                  </div>
                  <div className="text-gray-600" data-id="element-442">
                    Genuine enthusiasm for the sport and helping others discover
                    running
                  </div>
                </div>
              </li>

              <li className="flex items-start gap-4" data-id="element-443">
                <div className="w-6 h-6 bg-[#01AAE7] rounded-full flex items-center justify-center flex-shrink-0 mt-1" data-id="element-444">
                  <CheckCircle2 className="h-4 w-4 text-white" data-id="element-445" />
                </div>
                <div data-id="element-446">
                  <div className="font-bold text-gray-900 mb-1 text-lg" data-id="element-447">
                    Brand Alignment
                  </div>
                  <div className="text-gray-600" data-id="element-448">
                    Share RaceLookup's values of inclusivity, community, and
                    excellence
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Application Section */}
      <section className="py-16 sm:py-20 bg-gradient-to-br from-[#0E578E] to-[#01AAE7] relative overflow-hidden" data-id="element-449">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10" data-id="element-450">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-451"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-452"></div>
        </div>

        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10" data-id="element-453">
          <div className="text-center mb-8" data-id="element-454">
            <h2 className="text-3xl sm:text-4xl font-black text-white mb-4" data-id="element-455">
              Ready to Join Our Team?
            </h2>
            <p className="text-lg text-white/90" data-id="element-456">
              Apply now to become a RaceLookup Brand Ambassador and start making
              an impact
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 sm:p-8 border border-white/20" data-id="element-457">
            <form className="space-y-4" data-id="element-458">
              <div className="grid sm:grid-cols-2 gap-4" data-id="element-459">
                <input type="text" placeholder="First Name" className="w-full px-4 py-3 bg-white/95 backdrop-blur-sm border-2 border-white/20 rounded-xl focus:outline-none focus:border-white text-gray-900 placeholder:text-gray-500 transition-all" data-id="element-460" />
                <input type="text" placeholder="Last Name" className="w-full px-4 py-3 bg-white/95 backdrop-blur-sm border-2 border-white/20 rounded-xl focus:outline-none focus:border-white text-gray-900 placeholder:text-gray-500 transition-all" data-id="element-461" />
              </div>
              <input type="email" placeholder="Email Address" className="w-full px-4 py-3 bg-white/95 backdrop-blur-sm border-2 border-white/20 rounded-xl focus:outline-none focus:border-white text-gray-900 placeholder:text-gray-500 transition-all" data-id="element-462" />
              <input type="text" placeholder="Instagram Handle (optional)" className="w-full px-4 py-3 bg-white/95 backdrop-blur-sm border-2 border-white/20 rounded-xl focus:outline-none focus:border-white text-gray-900 placeholder:text-gray-500 transition-all" data-id="element-463" />
              <textarea placeholder="Tell us why you'd be a great Brand Ambassador (200 words max)" rows={4} className="w-full px-4 py-3 bg-white/95 backdrop-blur-sm border-2 border-white/20 rounded-xl focus:outline-none focus:border-white text-gray-900 placeholder:text-gray-500 transition-all resize-none" data-id="element-464"></textarea>
              <button type="submit" className="group w-full px-6 py-4 bg-white text-[#0E578E] font-bold rounded-xl hover:bg-gray-100 transition-all shadow-xl hover:shadow-2xl transform hover:-translate-y-0.5 flex items-center justify-center gap-2 text-base" data-id="element-465">
                <span data-id="element-466">Submit Application</span>
                <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-467" />
              </button>
            </form>

            <p className="text-white/70 text-sm text-center mt-4" data-id="element-468">
              Applications are reviewed on a rolling basis. We'll get back to
              you within 2 weeks.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 sm:py-20 bg-white" data-id="element-469">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-470">
          <div className="text-center mb-12" data-id="element-471">
            <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-4" data-id="element-472">
              Frequently Asked Questions
            </h2>
          </div>

          <div className="space-y-6" data-id="element-473">
            <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-474">
              <h3 className="text-lg font-black text-gray-900 mb-2" data-id="element-475">
                Is there a cost to become an ambassador?
              </h3>
              <p className="text-gray-600" data-id="element-476">
                No! The Brand Ambassador program is completely free. We provide
                you with gear, discounts, and opportunities at no cost.
              </p>
            </div>

            <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-477">
              <h3 className="text-lg font-black text-gray-900 mb-2" data-id="element-478">
                How much time commitment is required?
              </h3>
              <p className="text-gray-600" data-id="element-479">
                We ask for approximately 3-5 hours per month, which includes
                social media posts, attending events, and engaging with the
                community. Flexibility is built in to accommodate your schedule.
              </p>
            </div>

            <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-480">
              <h3 className="text-lg font-black text-gray-900 mb-2" data-id="element-481">
                Do I need a large social media following?
              </h3>
              <p className="text-gray-600" data-id="element-482">
                Not at all! We value authentic engagement over follower count.
                Whether you have 100 or 10,000 followers, what matters is your
                passion and genuine connection with the running community.
              </p>
            </div>

            <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-483">
              <h3 className="text-lg font-black text-gray-900 mb-2" data-id="element-484">
                How long is the ambassador term?
              </h3>
              <p className="text-gray-600" data-id="element-485">
                Ambassador terms are typically 12 months, with the option to
                renew. This gives you plenty of time to make an impact and enjoy
                the benefits.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}